import { render, staticRenderFns } from "./CompanyCourses.vue?vue&type=template&id=f3067b1a&scoped=true"
import script from "./CompanyCourses.vue?vue&type=script&lang=js"
export * from "./CompanyCourses.vue?vue&type=script&lang=js"
import style0 from "./CompanyCourses.vue?vue&type=style&index=0&id=f3067b1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3067b1a",
  null
  
)

export default component.exports